import {
  FIRST_NAME,
  LAST_NAME,
  GENDER,
  BIRTH,
  ADDRESS,
  CARE_OF,
  CANTON,
  COUNTRY,
  ZIP_CODE,
  CITY,
  PHONE,
  EMAIL,
  NATIONAL,
  SUB_COMPANY,
  NUMBER,
  // VEKA,
  MODEL,
  SUPPLEMENT,
  SSN,
  CORRESPONDENCE,
  WARD,
  TITLE,
  NURSING_HOME,
  INSTITUTION,
  INSURANCE,
  OTHER_CONTACTS,
  AGENT,
  FAMILY_DOCTOR,
  EYE_DOCTOR,
  OPTICIAN,
  GUARANTY,
  SUB_ORGANIZATION,
  NO_REPORT,
  RECURRING_EXAMINATION,
  MEDIA,
  REMUNERATION,
  TIERS_PAYANT,
  LAW_TYPE,
  LAW_TYPE_KINDS,
  IS_EMERGENCY,
  INVOICE_ONLY,
  REPORT_ONLY,
} from 'store/patients';

export const MODELS = {
  MANAGED_CARE: 'Managed Care',
  FREE_DOCTOR_CHOICE: 'Freie Arztwahl',
  OTHER: 'Anderes',
  UNKNOWN: 'Unbekannt',
};

export const contactValues = {
  [CORRESPONDENCE]: false,
  [IS_EMERGENCY]: false,
  [TITLE]: '',
  [FIRST_NAME]: '',
  [LAST_NAME]: '',
  [INSTITUTION]: '',
  [GENDER]: '',
  [ADDRESS]: '',
  [CANTON]: '',
  [COUNTRY]: 'CH',
  [ZIP_CODE]: '',
  [CITY]: '',
  [PHONE]: '',
  [EMAIL]: '',
};

export const defaultValues = {
  [TITLE]: '',
  [FIRST_NAME]: '',
  [LAST_NAME]: '',
  [BIRTH]: null,
  [GENDER]: '',
  [ADDRESS]: '',
  [CARE_OF]: '',
  [CANTON]: '',
  [COUNTRY]: 'CH',
  [ZIP_CODE]: '',
  [CITY]: '',
  [PHONE]: '',
  [EMAIL]: '',
  [NATIONAL]: 'CH',
  [MEDIA]: null,
  [NURSING_HOME]: {
    [SUB_ORGANIZATION]: null,
    [CORRESPONDENCE]: false,
    [WARD]: '',
  },
  [OPTICIAN]: {
    [SUB_ORGANIZATION]: null,
    [CORRESPONDENCE]: false,
    [GUARANTY]: false,
  },
  [INSURANCE]: {
    [SUB_COMPANY]: null,
    [NUMBER]: '',
    // [VEKA]: '',
    [MODEL]: '',
    [SUPPLEMENT]: null,
    [SSN]: '',
    [REMUNERATION]: TIERS_PAYANT,
    [LAW_TYPE]: LAW_TYPE_KINDS.KVG,
  },
  [AGENT]: {
    ...contactValues,
    [INVOICE_ONLY]: false,
    [REPORT_ONLY]: false,
  },
  [OTHER_CONTACTS]: [],
  [FAMILY_DOCTOR]: {
    [SUB_ORGANIZATION]: null,
    [CORRESPONDENCE]: false,
  },
  [EYE_DOCTOR]: {
    [SUB_ORGANIZATION]: null,
    [CORRESPONDENCE]: false,
  },
  [NO_REPORT]: false,
  [RECURRING_EXAMINATION]: false,
};
